import useTranslation from 'hooks/useTranslation'
import Checkbox from 'components/inputs/Checkbox'
import React from 'react'

interface RecurringConsentProps {
  name: string
  checked: boolean
  disabled?: boolean
  onGateway?: boolean
  onChange: (checked: boolean) => void
}

const RecurringConsent: React.FC<RecurringConsentProps> = ({ name, checked, disabled, onGateway, onChange }) => {
  const { t } = useTranslation('payment')

  return (
    <div
      className='payment__recurring'
      onClick={event => event.stopPropagation()}>
      <Checkbox
        name={name}
        checked={checked}
        disabled={disabled}
        label={t(onGateway ? 'saveForRecurringOnGateway' : 'saveForRecurring')}
        changeHandler={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked)}
      />
    </div>
  )
}

export default RecurringConsent
